import React, { useEffect, useState } from "react";
import { Calendar, MapPin } from "lucide-react";
import { api } from "../../lib/auth";

export default function Events() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/portal/events").then((r) => setItems(r.data.items || [])).catch(() => {});
  }, []);
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-extrabold tracking-tight text-[#0B132B]">Events</h1>
        <p className="text-[#4B5563] mt-2">Workshops, support nights, trainings, and gatherings.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {items.map((e) => (
          <div key={e.id} className="bg-white rounded-2xl border border-gray-100 p-6">
            <div className="text-[10px] font-bold uppercase tracking-wider text-[#23803F] mb-2">{e.category}</div>
            <h3 className="font-bold text-[#0B132B] text-lg">{e.title}</h3>
            <p className="text-sm text-[#4B5563] mt-2">{e.description}</p>
            <div className="flex items-center gap-4 mt-4 text-xs text-[#4B5563]">
              <div className="flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5" aria-hidden="true" /> {new Date(e.starts_at).toLocaleString()}</div>
              <div className="flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5" aria-hidden="true" /> {e.location}</div>
            </div>
            {/* Phase 10 F-R-05 · truthful disable.  There is no RSVP
                persistence endpoint today; expose a disabled, event-
                scoped control so screen readers and sighted users see
                the same truthful state. */}
            <button
              type="button"
              disabled
              aria-disabled="true"
              aria-label={`RSVP for ${e.title} — coming soon`}
              title="RSVP coming soon"
              className="mt-5 btc-btn-outline text-xs cursor-not-allowed opacity-60"
            >
              RSVP · coming soon
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
